const miniCart = document.querySelector('mini-cart');
document.body.addEventListener('docapp-discount-code-remove', (e) => {
    miniCart?.getSectionsToRender();
});

// discount-successイベントのリスナーを追加する関数
function addDiscountSuccessListener(codes) {
    if (codes && codes.length > 0) {
        document.body.addEventListener('docapp-discount-success', (e) => {
            codes.forEach(code => {
                window.discountOnCartProApp.removeCode(code);
            });
        });
    }
}

// window.discountOnCartProApp が未定義の場合は初期化
if (typeof window.discountOnCartProApp === 'undefined') {
    window.discountOnCartProApp = {};
}

// 初期設定: codes プロパティが既に設定されている場合にコールバックを実行
if (typeof window.discountOnCartProApp["codes"] !== 'undefined') {
    addDiscountSuccessListener(window.discountOnCartProApp["codes"]);
} else {
    // 定期的に codes プロパティをチェックする
    const intervalId = setInterval(() => {
        if (typeof window.discountOnCartProApp["codes"] !== 'undefined') {
            addDiscountSuccessListener(window.discountOnCartProApp["codes"]);
            clearInterval(intervalId); // チェックを停止
        }
    }, 1000); // 1秒ごとにチェック
}